<template>
    <q-page>
        <div class="q-display-2">Obrazki</div>

        <div>
            <upload @uploaded="uploaded" inline/>
        </div>

        <div class="virtualCollectionWrapper" ref="virtualCollectionWrapper">
            <virtual-collection
                :collection="items"
                :height="virtualHeight"
                :width="virtualWidth"
                :cellSizeAndPositionGetter="cellSizeAndPositionGetter"
            >
                <image-viewer
                    slot="cell"
                    slot-scope="props"
                    :inline="true"
                    :model="props.data"
                    width="200"
                    height="200"
                    :deletable="true"/>
            </virtual-collection>
        </div>
    </q-page>
</template>

<script>
    import ImageViewer from './pole/viewers/ImageViewer'
    import FileUpload from './FileUpload'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import QCardMedia from 'quasar-framework/src/components/card/QCardMedia'
    import QUploader from 'quasar-framework/src/components/uploader/QUploader'
    import Upload from './Upload'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'

    export default {
        components: {QBtn, Upload, QUploader, QCardMedia, QCardMain, FileUpload, ImageViewer},
        name: 'Pictures',
        data () {
            return {
                loading: false,
                virtualWidth: 0,
                virtualHeight: 0,
                ro: undefined,
            }
        },
        computed: {
            items () {
                return this.$store.getters.pictures.map(p => ({
                    data: p
                }))
            },
        },
        mounted () {
            this.updateContainerDimensions();

            window.addEventListener('resize', this.updateContainerDimensions, 'false');
            if (window.ResizeObserver) {
                this.ro = new ResizeObserver(this.updateContainerDimensions)
                    .observe(this.$refs.virtualCollectionWrapper);
            }
        },
        beforeDestroy () {
            window.removeEventListener('resize', this.updateContainerDimensions);
            if (this.ro) {
                this.ro.unobserve(this.$refs.virtualCollectionWrapper);
                this.ro.disconnect();
            }
        },
        methods: {
            fetch () {
                this.$store.dispatch('fetchAll', {
                    what: 'file',
                })
            },
            uploaded () {
                this.fetch()
            },
            updateContainerDimensions() {
                if (this.$refs.virtualCollectionWrapper) {
                    const maxW = this.$refs.virtualCollectionWrapper.clientWidth;
                    const maxH = window.innerHeight - this.$refs.virtualCollectionWrapper.getBoundingClientRect().top
                    this.virtualWidth = maxW;
                    this.virtualHeight = maxH;
                }
            },
            cellSizeAndPositionGetter(item, index) {
                const partWidth = 200;
                const partHeight = 260;
                const maxCol = Math.floor( this.virtualWidth / partWidth)
                const totalSpace = this.virtualWidth - partWidth * maxCol;

                return {
                    width: partWidth,
                    height: partHeight,
                    x: (index % maxCol) * (partWidth + totalSpace/maxCol),
                    y: parseInt(index / maxCol) * partHeight
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .virtualCollectionWrapper {
        width: 100%;
        height: 100%;

        .vue-virtual-collection {
            scroll: auto;
        }
    }
</style>